import { Check } from "lucide-react";

const PricingTable = ({ tiers, platformName }) => (
  <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3" data-testid="pricing-table">
    {tiers.map((t) => (
      <div
        key={t.name}
        data-testid={`pricing-tier-${t.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        className={`relative flex flex-col rounded-2xl p-7 transition-transform duration-300 hover:-translate-y-1 ${
          t.popular ? "border border-volt/60 bg-cardink shadow-[0_0_40px_rgba(0,229,89,0.08)]" : "border border-white/[0.08] bg-surface"
        }`}
      >
        {t.popular && (
          <span className="absolute -top-3 left-6 rounded-full bg-volt px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-ink">
            Most Popular
          </span>
        )}
        <p className="font-display text-lg font-bold">{t.name}</p>
        <p className="mt-1 text-xs text-white/45">{t.contacts}</p>
        <div className="mt-4 flex items-baseline gap-1.5">
          <span className="font-display text-4xl font-extrabold tracking-tight">{t.monthly}</span>
          {t.monthly !== "Custom" && t.monthly !== "$0" && <span className="text-sm text-white/45">/mo monthly</span>}
        </div>
        {t.annual !== t.monthly && t.annual !== "Custom" && t.monthly !== "$0" && (
          <p className="mt-1 text-xs text-volt">{t.annual}/mo billed annually</p>
        )}
        <ul className="mt-6 flex-1 space-y-2.5">
          {t.features.map((f, i) => (
            <li key={i} className="flex items-start gap-2.5 text-sm text-white/70">
              <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-volt" strokeWidth={3} />
              {f}
            </li>
          ))}
        </ul>
      </div>
    ))}
    <p className="sr-only">Pricing for {platformName}</p>
  </div>
);

export default PricingTable;
